import { Injectable, OnDestroy } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';

import * as ClientsActions from './clients.actions';
import { ClientService } from 'services/client.service';
import { catchError, map, mergeMap, switchMap, takeUntil, tap } from 'rxjs/operators';
import { ClientInterface, ClientInterfaceWithId } from '@sk/sk-interfaces';
import { of, Subject } from 'rxjs';
import { environment } from 'environments/environment';


@Injectable()
export class ClientsEffects implements OnDestroy{
  unsubscribe$ = new Subject();

  constructor(private actions$: Actions,
              private clientService: ClientService) {
  }



  queryClients$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClientsActions.queryFireStoreClients),
      takeUntil(this.unsubscribe$),
      switchMap(() => this.clientService.queryStateChangesClients()),
      mergeMap(actions => actions),
      map(action => {
        if (action.payload.doc.exists) {
          const payload = {
            ...action.payload.doc.data() as ClientInterface,
            id: (action.payload.doc.id) ? action.payload.doc.id : null,
            exists: action.payload.doc.exists
          } as ClientInterfaceWithId;
          // FireStore Events:  'added' | 'removed' | 'modified'
          switch (action.type) {
            case 'added':
              return ClientsActions.fromFireStoreAddClient({ client: payload });
            case 'removed':
              return ClientsActions.fromFireStoreRemoveClient({ id: payload.id });
            case 'modified':
              return ClientsActions.fromFireStoreModifyClient({
                client: payload
              });
          }
        }
      }),
      catchError((error) => {
        if(!environment.production){
          console.error('Query Clients Error: ', error.error)
        }
        return of(ClientsActions.queryFireStoreClientsError({
          error
        }));
      })
    )
  );

// ToDo: Include error handled // effect
  updateClient$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClientsActions.updateClient),
      switchMap(action => {
        return this.clientService.updateClient(action.id, action.changes);
      }),
      map(() => ClientsActions.updateSuccess({})
      ),
      catchError((error) => {
        return of(ClientsActions.updateError({
          error
        }));
      })
    )
  );


  addClient$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClientsActions.addClient),
      switchMap(action => {
        return this.clientService.addClient(action.client);
      }),
      map(() => ClientsActions.addSuccess({})),
      catchError((err: Error) => {
        console.error(err);
        if(err) {
          return of(ClientsActions.addError({ error: err }));
        }
      })
    )
  );


  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
